import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { NotFoundError } from 'navi';

import { ErrorBlock } from './ErrorBlock';
import { Layout } from 'modules/entrypoint/LayoutCommon';
import { IntercomContext } from 'contexts/intercom';

export const NotFoundBlock = () => {
  const { t } = useTranslation(['common', 'glossary']);
  const { show } = useContext(IntercomContext);

  return (
    <Layout>
      <ErrorBlock
        text={t('common:errorsPages.notFound.text')}
        subText={t('common:errorsPages.notFound.subText')}
        buttonText={t('glossary:home')}
        handleOpenSupport={show}
      />
    </Layout>
  );
};

export const NotFoundLayout = (_: NotFoundError) => <NotFoundBlock />;
